import { getImgUrl } from '@utils/functions/getImgUrl';

const ProfileCard = ({ name, image, designation, companyLogo, linkedinUrl }) => {
  return (
    <div className="my-14 flex justify-start">
      <div className="flex flex-row rounded-lg shadow-md hover:shadow-lg md:max-w-xl">
        {image && (
          <img
            className="h-50 w-32 rounded-none rounded-l-lg object-cover"
            src={getImgUrl(image)}
            loading="lazy"
            alt=""
          />
        )}
        <div className="flex flex-col justify-center p-6">
          <h5 className="font-satoshi-bold text-2xl font-bold text-gray-900 ">{name}</h5>
          <h5 className="mt-0 text-sm">{designation}</h5>
          {companyLogo && (
            <img
              src={getImgUrl(companyLogo)}
              loading="lazy"
              alt="company"
              className="h-[42px] w-[120px] object-contain"
            />
          )}
          {linkedinUrl && (
            <a className="mt-2 ml-auto" href={linkedinUrl} target="_blank" rel="noreferrer">
              <img
                src="/assets/icons/courses-icons/LinkedIn@2x.png"
                alt=""
                style={{ height: '24px', width: '24px' }}
              />
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfileCard;
